import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavListItem } from '../../navigation.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-list',
  templateUrl: './nav-list.component.html',
})
export class NavListComponent {
  @Input() route: string;
  @Input() navItems: NavListItem[];

  activeItemLabel: string;

  subs: Subscription[] = [];

  constructor(private router: Router) {}

  handleChildClick(child: NavListItem): void {
    if (child.isExternal && child.route) {
      window.open(child.route, '_blank', 'noopener');
    } else if (child.route) {
      this.router.navigateByUrl(child.route, child.routeParams);
    } else if (child.action) {
      child.action();
    }
  }

  itemAction(item: NavListItem) {
    if (item.action) {
      item.action();
    }
    this.activeItemLabel = item.label;
  }

  isActiveRoute(item: NavListItem): boolean {
    if (this.activeItemLabel) {
      return this.activeItemLabel === item.label;
    }
    return this.route === item.route;
  }
}
